/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'tools.ozone.setting.defs'

export { $nsid }

type Option = {
  $type?: 'tools.ozone.setting.defs#option'
  key: l.NsidString
  did: l.DidString
  value: l.LexMap
  description?: string
  createdAt?: l.DatetimeString
  updatedAt?: l.DatetimeString
  managerRole?:
    | 'tools.ozone.team.defs#roleModerator'
    | 'tools.ozone.team.defs#roleTriage'
    | 'tools.ozone.team.defs#roleAdmin'
    | 'tools.ozone.team.defs#roleVerifier'
    | l.UnknownString
  scope: 'instance' | 'personal' | l.UnknownString
  createdBy: l.DidString
  lastUpdatedBy: l.DidString
}

export type { Option }

const option = l.typedObject<Option>(
  $nsid,
  'option',
  l.object({
    key: l.string({ format: 'nsid' }),
    did: l.string({ format: 'did' }),
    value: l.lexMap(),
    description: l.optional(l.string({ maxGraphemes: 1024, maxLength: 10240 })),
    createdAt: l.optional(l.string({ format: 'datetime' })),
    updatedAt: l.optional(l.string({ format: 'datetime' })),
    managerRole: l.optional(
      l.string<{
        knownValues: [
          'tools.ozone.team.defs#roleModerator',
          'tools.ozone.team.defs#roleTriage',
          'tools.ozone.team.defs#roleAdmin',
          'tools.ozone.team.defs#roleVerifier',
        ]
      }>(),
    ),
    scope: l.string<{ knownValues: ['instance', 'personal'] }>(),
    createdBy: l.string({ format: 'did' }),
    lastUpdatedBy: l.string({ format: 'did' }),
  }),
)

export { option }
